// Social media links
export const sharedlinks = {
  portfolio: 'https://yacouri.com',
  twitter: 'https://twitter.com/OfficialBafancy',
  instagram: 'https://instagram.com/minatemps',
  github: 'https://github.com/yacouri',
  product: 'https://bafancy.gumroad.com/l/twitter-linkedin-banners',
  waitlist: 'https://app.bafancy.com'
};
